module.exports = {
  siteName: "Play GGPL",
  copyright: "Copyright © All rights reserved |  ",
  logoPath: "/image/logo.png",
  apiPrefix: `${"http://play.gaviral.in"}`,
  socketURL: `${
    process.env.NODE_ENV === "production" ? process.env.SOCKET_URL : "http://play.gaviral.in"
  }`,
  reportDownloadUrl: `${"http://play.gaviral.in"}/reports`,
  uploadMediaUrl: `${"http://play.gaviral.in"}/media`,
  apiURL: `${"http://play.gaviral.in"}/api`,
};
